/**
 * Default Mapping
 * Most mappings will inherit this mapping
 */
var defaultMapping = [
  {
    apiProperty: 'id',
    vueProperty: 'id',
    type: 'toNumber'
  },
  {
    apiProperty: 'name',
    vueProperty: 'name'
  },
  {
    apiProperty: 'description',
    vueProperty: 'description'
  },
  {
    apiProperty: 'published',
    vueProperty: 'published',
    type: 'toBoolean'
  }
];
export default {
  /**
   * Product Mappings
   */
  productMapDefinition: [
    ...defaultMapping,
    {
      apiProperty: 'sku',
      vueProperty: 'sku'
    },
    {
      apiProperty: 'productTypeId',
      vueProperty: 'productTypeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'sellPrice',
      vueProperty: 'sellPrice',
      type: 'toNumber'
    },
    {
      apiProperty: 'sellAsType',
      vueProperty: 'sellAsType'
    },
    {
      apiProperty: 'variantOfProductId',
      vueProperty: 'variantOfProductId',
      type: 'toNumber'
    },
    {
      apiProperty: 'quantityFormula',
      vueProperty: 'quantityFormula'
    },
    {
      apiProperty: 'quantityFormulaDescription',
      vueProperty: 'quantityFormulaDescription'
    },
    {
      apiProperty: 'longDescription',
      vueProperty: 'longDescription'
    },
    {
      apiProperty: 'detailsSource',
      vueProperty: 'detailsSource'
    }
  ],
  /**
   * Attribute Mappings
   */
  attributeMapDefinition: [
    ...defaultMapping,
    {
      apiProperty: 'controlType',
      vueProperty: 'controlType'
    },
    {
      apiProperty: 'sigMessage',
      vueProperty: 'sigMessage'
    }
  ],
  /**
   * Attribute Value Mappings
   */
  attributeValueMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'label',
      vueProperty: 'label'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    },
    {
      apiProperty: 'published',
      vueProperty: 'published',
      type: 'toBoolean'
    }
  ],
  /**
   * Product Type Mappings
   */
  productTypeMapDefinition: [...defaultMapping],
  /**
   * Sell As Type Mappings
   */
  sellAsTypeMapDefinition: [
    ...defaultMapping,
    {
      apiProperty: 'value',
      vueProperty: 'value'
    }
  ],
  /**
   * System Mappings
   */
  systemMapDefinition: [
    ...defaultMapping,
    {
      apiProperty: 'systemType',
      vueProperty: 'systemType'
    }
  ],
  /**
   * Subsystem Mappings
   */
  subsystemMapDefinition: [
    ...defaultMapping,
    {
      apiProperty: 'systemDefinitionId',
      vueProperty: 'systemDefinitionId',
      type: 'toNumber'
    },
    {
      apiProperty: 'subsystemType',
      vueProperty: 'subsystemType'
    },
    {
      apiProperty: 'userType',
      vueProperty: 'userType'
    }
  ],
  /**
   * Component Mappings
   */
  componentMapDefinition: [
    ...defaultMapping,
    {
      apiProperty: 'subsystemDefinitionId',
      vueProperty: 'subsystemDefinitionId',
      type: 'toNumber'
    },
    {
      apiProperty: 'productTypeId',
      vueProperty: 'productTypeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'sequence',
      vueProperty: 'sequence',
      type: 'toNumber'
    },
    {
      apiProperty: 'stepLabel',
      vueProperty: 'stepLabel'
    },
    {
      apiProperty: 'maxQuantity',
      vueProperty: 'maxQuantity',
      type: 'toNumber'
    },
    {
      apiProperty: 'defaultQuantityFromSetting',
      vueProperty: 'defaultQuantityFromSetting',
      type: 'toNumber'
    },
    {
      apiProperty: 'sigMessage',
      vueProperty: 'sigMessage'
    }
  ],
  /**
   * Product Images
   */
  productImageMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'productId',
      vueProperty: 'productId',
      type: 'toNumber'
    },
    {
      apiProperty: 'imageType',
      vueProperty: 'imageType'
    },
    {
      apiProperty: 'displayOrder',
      vueProperty: 'displayOrder',
      type: 'toNumber'
    },
    {
      apiProperty: 'fileExtension',
      vueProperty: 'fileExtension'
    },
    {
      apiProperty: 'url',
      vueProperty: 'url'
    }
  ],
  /**
   * Product Accessory Mappings
   */
  productAccessoryMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'productId',
      vueProperty: 'productId',
      type: 'toNumber'
    },
    {
      apiProperty: 'minQuantity',
      vueProperty: 'minQuantity',
      type: 'toNumber'
    },
    {
      apiProperty: 'maxQuantity',
      vueProperty: 'maxQuantity',
      type: 'toNumber'
    },
    {
      apiProperty: 'required',
      vueProperty: 'required',
      type: 'toBoolean'
    },
    {
      apiProperty: 'configurable',
      vueProperty: 'configurable',
      type: 'toBoolean'
    },
    {
      apiProperty: 'defaultToParentQuantity',
      vueProperty: 'defaultToParentQuantity',
      type: 'toBoolean'
    }
  ],
  /**
   * Product Attribute Value Mappings
   */
  productAttributeValueMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    },
    {
      apiProperty: 'productId',
      vueProperty: 'productId',
      type: 'toNumbera'
    }
  ],
  /**
   * Product Requirement Mappings
   */
  productRequirementMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'productId',
      vueProperty: 'productId',
      type: 'toNumber'
    },
    {
      apiProperty: 'childProductTypeId',
      vueProperty: 'childProductTypeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'childProductType',
      vueProperty: 'childProductType'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'requirementType',
      vueProperty: 'requirementType'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    }
  ],
  /**
   * Product Setting Mappings
   */
  productSettingMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'productId',
      vueProperty: 'productId',
      type: 'toNumber'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'label',
      vueProperty: 'label'
    },
    {
      apiProperty: 'valueSuffix',
      vueProperty: 'valueSuffix'
    },
    {
      apiProperty: 'sigMessage',
      vueProperty: 'sigMessage'
    },
    {
      apiProperty: 'published',
      vueProperty: 'published',
      type: 'toBoolean'
    }
  ],
  /**
   * Control Type Mappings
   */
  controlTypeMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    },
    {
      apiProperty: 'name',
      vueProperty: 'name'
    }
  ],
  /**
   * Requirement Type Mappings
   */
  requirementTypeMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    },
    {
      apiProperty: 'name',
      vueProperty: 'name'
    }
  ],
  /**
   * Component Requirement Mappings
   */
  componentRequirementMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'componentDefinitionId',
      vueProperty: 'componentDefinitionId',
      type: 'toNumber'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'requirementType',
      vueProperty: 'requirementType'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    },
    {
      apiProperty: 'componentSettingDefinitionId',
      vueProperty: 'componentSettingDefinitionId'
    },
    {
      apiProperty: 'targetEntity',
      vueProperty: 'targetEntity'
    }
  ],
  /**
   * Component Setting Mappings
   */
  componentSettingMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'label',
      vueProperty: 'label'
    },
    {
      apiProperty: 'controlType',
      vueProperty: 'controlType'
    },
    {
      apiProperty: 'valueSuffix',
      vueProperty: 'valueSuffix'
    },
    {
      apiProperty: 'componentDefinitionId',
      vueProperty: 'componentDefinitionId',
      type: 'toNumber'
    },
    {
      apiProperty: 'published',
      vueProperty: 'published',
      type: 'toBoolean'
    },
    {
      apiProperty: 'required',
      vueProperty: 'required',
      type: 'toBoolean'
    },
    {
      apiProperty: 'sigMessage',
      vueProperty: 'sigMessage'
    }
  ],
  /**
   * Project Setting Mappings
   */
  projectSettingMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'attributeId',
      vueProperty: 'attributeId',
      type: 'toNumber'
    },
    {
      apiProperty: 'label',
      vueProperty: 'label'
    },
    {
      apiProperty: 'controlType',
      vueProperty: 'controlType'
    },
    {
      apiProperty: 'valueSuffix',
      vueProperty: 'valueSuffix'
    },
    {
      apiProperty: 'published',
      vueProperty: 'published',
      type: 'toBoolean'
    }
  ],
  /**
   * UserType Mappings
   */
  userTypeMapDefinition: [
    {
      apiProperty: 'id',
      vueProperty: 'id',
      type: 'toNumber'
    },
    {
      apiProperty: 'projectSettingDefinitionId',
      vueProperty: 'projectSettingDefinitionId',
      type: 'toNumber'
    },
    {
      apiProperty: 'label',
      vueProperty: 'label'
    },
    {
      apiProperty: 'value',
      vueProperty: 'value'
    },
    {
      apiProperty: 'published',
      vueProperty: 'published',
      type: 'toBoolean'
    },
    {
      apiProperty: 'sigMessageModel',
      vueProperty: 'sigMessageModel'
    }
  ]
};
